import { render } from "./manage-employees.vue?vue&type=template&id=1568331f"
import script from "./manage-employees.vue?vue&type=script&lang=js"
export * from "./manage-employees.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__